import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader, FlipCard } from "../shared";
import { QuotationService } from "../../services";

const Quotations = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    getActiveQuotations();
  }, []);

  const getActiveQuotations = async () => {
    try {
      setLoading(true);
      const quotations = await QuotationService.getQuotations();
      setData(quotations);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Loader show={loading} />

      <section className="margin">
        <div className="container-fluid">
          <div className="ah-page-title">
            <h2 className="mb-0">{t("track.quotations")}</h2>
          </div>
        </div>
      </section>

      <section className="pt-0 recent-offers margin">
        <div className="container-fluid recent-offer-main">
          <div className="row">
            {data?.map((offer) => ( 
              <FlipCard key={offer?.id} offer={offer} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Quotations;
